"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_UPDATED_LOG = exports.ADD_UPDATED_LOG = "ADD_UPDATED_LOG";

var CHANGE_BUTTON_STATUS = exports.CHANGE_BUTTON_STATUS = "CHANGE_BUTTON_STATUS";

var DEVELOPMENT_ENV_CHANGE = exports.DEVELOPMENT_ENV_CHANGE = "DEVELOPMENT_ENV_CHANGE";

var DEVELOPMENT_LOG = exports.DEVELOPMENT_LOG = "DEVELOPMENT_LOG";

var DEVELOPMENT_KUBECTL_DATA = exports.DEVELOPMENT_KUBECTL_DATA = "DEVELOPMENT_KUBECTL_DATA";
//# sourceMappingURL=developmentConstants.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/development/developmentConstants.js
// module id = 157
// module chunks = 0